<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar acessos / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="update">
                                    <div class="row mt-1">
                                        <div class="col-xl-4 col-md-3 col-sm-12">
                                            <label for="">Banco</label>
                                            <multiselect v-model="bank_multiselect" :options="banks_options"
                                                :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                                :select-label="'Clique para selecionar'"
                                                :deselect-label="'Clique para remover'" @select="handleSelectBank">

                                                <template #noResult>
                                                    Nenhum banco encontrado.
                                                </template>
                                            </multiselect>

                                        </div>
                                        <div class="col-xl-2 col-md-3 col-sm-12">
                                            <label for="">Agência</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_access.agency">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Conta</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_access.account">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Tipo conta</label>
                                            <multiselect v-model="client_access.type_account"
                                                :options="type_account_options" placeholder="Selecione uma opção"
                                                :select-label="'Clique para selecionar'"
                                                :deselect-label="'Clique para remover'">
                                                <template #noResult>
                                                    Nenhum tipo de conta encontrado.
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Senha GOV</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: *****"
                                                    v-model="client_access.password_gov">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">DET</label>
                                            <div class="input-group mb-3">
                                                <multiselect v-model="det_multiselect" :options="det_options"
                                                    placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'" :custom-label="detWithLang"
                                                    :deselect-label="'Clique para remover'" @select="handleSelectDet">
                                                    <template #noResult>
                                                        Opção não encontrada.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Frase DET</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: sua frase aqui"
                                                    v-model="client_access.word_det">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">DEC</label>
                                            <div class="input-group mb-3">
                                                <multiselect v-model="dec_multiselect" :options="dec_options"
                                                    placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'" :custom-label="decWithLang"
                                                    :deselect-label="'Clique para remover'" @select="handleSelectDec">
                                                    <template #noResult>
                                                        Opção não encontrada.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Link prefeitura</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: https://prefeitura.org"
                                                    v-model="client_access.link_prefecture">
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Usuário prefeitura</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: usuario@dominio.com"
                                                    v-model="client_access.user_prefecture">
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Senha prefeitura</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: *****"
                                                    v-model="client_access.password_prefecture">
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Procuração Soul</label>
                                            <multiselect v-model="procuration_multiselect"
                                                :options="procuration_options" placeholder="Selecione uma opção"
                                                :select-label="'Clique para selecionar'"
                                                :custom-label="procurationWithLang"
                                                :deselect-label="'Clique para remover'"
                                                @select="handleSelectProcuration">
                                                <template #noResult>
                                                    Nenhum tipo de procuração encontrado.
                                                </template>
                                            </multiselect>
                                        </div>
                                         <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Vencimento procuração</label>
                                            <div class="input-group mb-3">
                                                <input type="date" class="form-control"
                                                    v-model="client_access.due_date_procuration">
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Código SN</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: *****"
                                                    v-model="client_access.code_sn">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-4">
                                        <div class="col-lg-12 col-xs-12 col-sm-12">
                                            <label for="">Observações</label>
                                            <editorText @update-text="updateObservation"
                                                :modelValue="client_access.observation"
                                                placeholderSend="Sem observações" ref="myChild"></editorText>
                                        </div>
                                    </div>
                                    <br> <br>
                                    <div class="row mt-3">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <router-link to="/client" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { loadBank } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import tabMenuClient from './tab-menu-client.vue';
import Multiselect from 'vue-multiselect'


export default {
    directives: { mask },
    components: { Loading, editorText, tabMenuClient, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            banks: {},
            bank_multiselect: '',
            procuration_multiselect: '',
            dec_multiselect: '',
            det_multiselect: '',
            client_id: '',
            banks_options: [],
            type_account_options: ['Conta Corrente', 'Conta Poupança'],
            procuration_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            dec_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            det_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            client_access: {
                id: '',
                bank: '',
                agency: '',
                account: '',
                type_account: '',
                password_gov: '',
                det: '',
                word_det: '',
                dec: '',
                procuration: '',
                due_date_procuration:'',
                code_sn: '',
                link_prefecture: '',
                user_prefecture: '',
                password_prefecture: '',
                observation: ''
            },
            enable_error_list: false,
            errors: [],
        }
    },

    computed: {
        isDisabled: function () {
            return true;
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        const response_banks = this.getBank();
        response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({
                title: item.fullName,
                value: 'Código: ' + item.code + ' / ' + 'Banco: ' + capitalize(item.name)
            }));
        });
        this.getAccessClient();

    },
    methods: {
        onCancel() { },
        setCapitalize(text) {
            return capitalize(text);
        },
        handleSelectBank(option) {
            this.client_access.bank = option.value;
        },
        handleSelectProcuration(option) {
            this.client_access.procuration = option.type;
        },
        handleSelectDet(option) {
            this.client_access.det = option.type;
        },

        handleSelectDec(option) {
            this.client_access.dec = option.type;
        },
        bankWithLang({ value }) {
            return value;
        },
        procurationWithLang({ value }) {
            return value;
        },
        detWithLang({ value }) {
            return value;
        },
        decWithLang({ value }) {
            return value;
        },
        async getBank() {
            this.isLoading = true;
            const response = await loadBank().then((response) => {
                let banks = response;
                banks.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    return 0;
                });
                this.banks = banks;

                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });

            return response;
        },

        updateObservation(observation) {
            this.client_access.observation = observation;
        },
        getAccessClient() {
            api.get('/client/' + this.client_id + '/sensitiveData')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    if (response.data.sensitive_data_client.length != 0) {
                        this.client_access = response.data.sensitive_data_client;
                        this.$refs.myChild.updateTextEditor(this.client_access.observation);
                        if (this.client_access.bank) {
                            this.bank_multiselect = { title: this.client_access.bank, value: this.client_access.bank };
                        }
                        if (this.client_access.procuration == '1') {
                            this.procuration_multiselect = { type: '1', value: 'Sim' };
                        } else {
                            this.procuration_multiselect = { type: '0', value: 'Não' };
                        }

                        if (this.client_access.dec == '1') {
                            this.dec_multiselect = { type: '1', value: 'Sim' };
                        } else {
                            this.dec_multiselect = { type: '0', value: 'Não' };
                        }

                        if (this.client_access.det == '1') {
                            this.det_multiselect = { type: '1', value: 'Sim' };
                        } else {
                            this.det_multiselect = { type: '0', value: 'Não' };
                        }
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client/' + this.client.id + '/sensitiveData', this.client_access)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Dados de acesso do cliente atualizados com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>